import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  CardContent,
  Fab,
  FormControl,
  FormGroup,
  Grid,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Search } from "@material-ui/icons";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import TableData from "../components/TableData";
import datetimeHelper from "../helper/datetime-helper";
import { globalHistory } from "../history";
import { mapActionsToProps } from "../redux/roles";

class Roles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {},
        page: 0,
        pageSize: 20,
      },
      showPassword: false,
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    await this.itemInit();
  }

  listCollumns = [
    {
      id: "allowedRoles",
      numeric: true,
      disablePadding: false,
      label: "Tên quyền",
    },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian tạo",
    },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "username":
            case "fullname":
            case "phoneNumber":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getRole(filters.order, filters.pageSize, filters.page, {
      where,
    });
  }

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleChangeCheck = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleChangeCheckItem = (name) => (event) => {
    this.setState({
      item: {
        ...this.state.item,
        [name]: event.target.checked,
      },
    });
  };

  // handleCreateModel = () => {
  //   this.setState({ modalAction: true, item: {} })
  // }

  // handleAction = () => {
  //   const { id } = this.state.item;
  //   if (!id) {
  //     const { username, password, fullname, email, phoneNumber, status } = this.state;
  //     return (
  //       this.props.addRole(username, password, fullname, email, phoneNumber, status),
  //       setTimeout(
  //         function () {
  //           this.setState({ modalAction: false });
  //           this.itemInit()
  //         }.bind(this), 500
  //       )
  //     )
  //   } else {
  //     const { id, username, fullname, email, phoneNumber, status } = this.state.item
  //     return (
  //       this.props.editRole(id, username, this.state.password, fullname, email, phoneNumber, status),
  //       setTimeout(
  //         function () {
  //           this.setState({ modalAction: false });
  //           this.itemInit()
  //         }.bind(this), 500
  //       )
  //     )
  //   }
  // }

  // handleDelete = () => {
  //   this.props.deleteRole(this.state.item.id)
  //   setTimeout(
  //     function () {
  //       this.setState({ modalDelete: false });
  //     }.bind(this), 500
  //   );
  //   this.itemInit()
  // }

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  render() {
    const { classes, listRole, count } = this.props;
    const {
      filters,
      username,
      password,
      fullname,
      email,
      phoneNumber,
      status,
      item,
      modalDelete,
    } = this.state;
    const listRoleResult =
      typeof listRole === "object"
        ? Object.keys(listRole).map((key) => listRole[key])
        : listRole;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tài khoản"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.username}
                          name="username"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Fab
                          color="secondary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách quyền"
          items={listRoleResult}
          rowsPerPage={filters.pageSize}
          count={listRoleResult.length}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </React.Fragment>
    );
  }
}

Roles.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  grid: {
    width: "100%",
    padding: theme.spacing.unit * 3,
  },
});

const mapStateToProps = (state) => ({
  listRole: state.roles.roles,
});

Roles = connect(mapStateToProps, mapActionsToProps)(Roles);

export default withStyles(styles)(Roles);
